import { useEffect } from 'react'

export const useRefetchData = (shouldRefetchData, refetch) => {
  useEffect(() => {
    if (shouldRefetchData) {
      refetch()
    }
  }, [shouldRefetchData, refetch])
}
